import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Search, UserPlus, Users, User } from 'lucide-react';
export const Customers: React.FC = () => {
  const {
    patients,
    walkInClients,
    addWalkInClient,
    logBillingAudit
  } = useData();
  const [activeTab, setActiveTab] = useState<'registered' | 'walkin'>('registered');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddWalkIn, setShowAddWalkIn] = useState(false);
  const [walkInForm, setWalkInForm] = useState({
    name: '',
    phone: '',
    nrcPassport: '',
    email: '',
    address: ''
  });
  const filteredPatients = patients.filter(p => p.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || p.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || p.bmcFileNumber.toLowerCase().includes(searchQuery.toLowerCase()) || p.contact.includes(searchQuery));
  const filteredWalkIns = walkInClients.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.phone && c.phone.includes(searchQuery) || c.nrcPassport && c.nrcPassport.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleAddWalkIn = (e: React.FormEvent) => {
    e.preventDefault();
    const newClient = addWalkInClient(walkInForm);
    logBillingAudit('Create Walk-in Client', `Created walk-in client ${newClient.name}`);
    setShowAddWalkIn(false);
    setWalkInForm({
      name: '',
      phone: '',
      nrcPassport: '',
      email: '',
      address: ''
    });
    setActiveTab('walkin');
  };
  return <div className="space-y-6" data-id="element-1012">
      <div className="flex justify-between items-center" data-id="element-1013">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1014">Customers</h1>
        <Button onClick={() => setShowAddWalkIn(true)} data-id="element-1015">
          <UserPlus className="w-4 h-4 mr-2" data-id="element-1016" /> New Walk-in Client
        </Button>
      </div>

      <Card noPadding data-id="element-1017">
        <div className="border-b border-gray-200" data-id="element-1018">
          <nav className="flex -mb-px" data-id="element-1019">
            <button onClick={() => setActiveTab('registered')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'registered' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1020">
              <Users className="w-5 h-5 inline-block mr-2" data-id="element-1021" />
              Registered Patients ({patients.length})
            </button>
            <button onClick={() => setActiveTab('walkin')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'walkin' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1022">
              <User className="w-5 h-5 inline-block mr-2" data-id="element-1023" />
              Walk-in Clients ({walkInClients.length})
            </button>
          </nav>
        </div>

        <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-1024">
          <div className="relative max-w-md" data-id="element-1025">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1026">
              <Search className="h-5 w-5 text-gray-400" data-id="element-1027" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search customers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1028" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-1029">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1030">
            <thead className="bg-gray-50" data-id="element-1031">
              <tr data-id="element-1032">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1033">
                  {activeTab === 'registered' ? 'BMC Number' : 'Client ID'}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1034">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1035">
                  Contact
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1036">
                  {activeTab === 'registered' ? 'Age/Sex' : 'NRC/Passport'}
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1037">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1038">
              {activeTab === 'registered' ? filteredPatients.length > 0 ? filteredPatients.map(patient => <tr key={patient.id} className="hover:bg-gray-50" data-id="element-1039">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1040">
                        {patient.bmcFileNumber}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1041">
                        {patient.firstName} {patient.lastName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1042">
                        {patient.contact}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1043">
                        {patient.age} / {patient.sex}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1044">
                        <Button variant="outline" size="sm" data-id="element-1045">
                          Create Invoice
                        </Button>
                      </td>
                    </tr>) : <tr data-id="element-1046">
                    <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1047">
                      No registered patients found.
                    </td>
                  </tr> : filteredWalkIns.length > 0 ? filteredWalkIns.map(client => <tr key={client.id} className="hover:bg-gray-50" data-id="element-1048">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500" data-id="element-1049">
                      {client.id.split('-')[1]}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1050">
                      {client.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1051">
                      {client.phone || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1052">
                      {client.nrcPassport || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1053">
                      <Button variant="outline" size="sm" data-id="element-1054">
                        Create Invoice
                      </Button>
                    </td>
                  </tr>) : <tr data-id="element-1055">
                  <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1056">
                    No walk-in clients found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Add Walk-in Client Modal */}
      {showAddWalkIn && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1057">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1058">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1059">
              New Walk-in Client
            </h3>
            <form onSubmit={handleAddWalkIn} className="space-y-4" data-id="element-1060">
              <Input label="Full Name" required value={walkInForm.name} onChange={e => setWalkInForm({
            ...walkInForm,
            name: e.target.value
          })} data-id="element-1061" />
              <Input label="Phone Number (Optional)" value={walkInForm.phone} onChange={e => setWalkInForm({
            ...walkInForm,
            phone: e.target.value
          })} data-id="element-1062" />
              <Input label="NRC/Passport (Optional)" value={walkInForm.nrcPassport} onChange={e => setWalkInForm({
            ...walkInForm,
            nrcPassport: e.target.value
          })} data-id="element-1063" />
              <Input label="Email (Optional)" type="email" value={walkInForm.email} onChange={e => setWalkInForm({
            ...walkInForm,
            email: e.target.value
          })} data-id="element-1064" />
              <Input label="Address (Optional)" value={walkInForm.address} onChange={e => setWalkInForm({
            ...walkInForm,
            address: e.target.value
          })} data-id="element-1065" />
              <div className="flex justify-end space-x-3 mt-6" data-id="element-1066">
                <Button variant="outline" type="button" onClick={() => setShowAddWalkIn(false)} data-id="element-1067">
                  Cancel
                </Button>
                <Button type="submit" data-id="element-1068">Save Client</Button>
              </div>
            </form>
          </div>
        </div>}
    </div>;
};